/*
 * @Description: 已支付
 * @Date: 2020-12-12 17:48:46
 */
import fields from './fields';
import { projectPriceHanderl } from './fields';
import search from './search';

import TableRenderClass from '@/components/tableRender/tableRenderClass';
import {
  listPayOrderPeopleAndSupplie,
  totalPayOrderPeopleAndSupplie
  // listPayOrderPeopleAndSupplieExportZip
} from '@/api/ajax';
// import receiptDownload from '@/page/settlementCenter/utils/receiptDownload.js';
// import dateFormat from '@/tools/dateFormat.js';

// const downloadReceipt = {
//   name: '下载全部回单',
//   type: 'primary',
//   fn: (app, table) => {
//     if (table.tableData.length) {
//       receiptDownload(
//         table.searchQuery,
//         listPayOrderPeopleAndSupplieExportZip,
//         '',
//         `${dateFormat(new Date())}_全部下载`
//       );
//     }
//   }
// };

let example = new TableRenderClass({ fields, search });

// 页面入口
const part = example.createPart({
  name: '订单详情',
  search: ['orderNo', 'projectName', 'createDate', 'payee', 'phone'],
  list: listPayOrderPeopleAndSupplie,
  fields: [
    'index',
    'orderNo',
    'payProjectStructureType',
    'payee',
    'userPhone',
    'projectName',
    'createDate',
    'finishSum',
    'taskPrice',
    'finishSumTaskPrice',
    projectPriceHanderl(3),
    'payStatus03',
    'finishPayDt',
    'endPointFinishPayDt',
    'download'
  ]
  // moreBtnArr: [downloadReceipt]
});

// individualAjax 为独立注册字段，用于获取总价接口
export default {
  name: '订单详情',
  childMenu: [{ ...part, individualAjax: totalPayOrderPeopleAndSupplie }]
};
